import { useEffect } from "react";
import {
  getDatabase,
  ref,
  onChildAdded,
  off,
  query,
  orderByChild,
  startAt,
} from "firebase/database";

const GlobalNotificationListener = () => {
  useEffect(() => {
    const db = getDatabase();

    const types = [
      "Steel Orders",
      "New Query",
      "Negotiations",
      "Quotations",
      "Raised Issues",
      "Machinery Orders",
      "transportGoods",
      "Stop_Order",
      "Refund",
      "finance",
      "New Orders",
      "Document Verification",
      "Docs_Request",
      "firm_requests",
      "Transport_Goods",
    ];

    // Ask permission once
    if (Notification.permission !== "granted") {
      Notification.requestPermission();
    }

    const listeners = [];

    // Prevent duplicates
    const shownNotifications = new Set();

    // Ignore old notifications
    const startTime = Date.now();

    types.forEach((type) => {
      const baseRef = ref(db, `supplier_notifications/${type}`);

      // Only listen to new notifications
      const typeQuery = query(
        baseRef,
        orderByChild("timestamp"),
        startAt(startTime)
      );

      listeners.push(typeQuery);

      onChildAdded(typeQuery, (snapshot) => {
        const notification = snapshot.val();
        const notificationId = snapshot.key;

        // Prevent repeat notifications
        if (shownNotifications.has(notificationId)) {
          return;
        }

        shownNotifications.add(notificationId);

        console.log("🔥 New notification:", type, notification);

        if (Notification.permission === "granted") {
          new Notification(type, {
            body: notification?.message || "New notification received",
            icon: "/logo192.png",
          });
        }
      });
    });

    return () => {
      listeners.forEach((typeRef) => {
        off(typeRef, "child_added");
      });
    };
  }, []);

  return null;
};

export default GlobalNotificationListener;